export enum TransactionAllowCategorizationEnum {
  FORBIDDEN = 'FORBIDDEN',
  READ = 'READ',
  READ_WRITE = 'READ_WRITE',
}
